<template>
    <div>
        <DAlert
            color="warning"
            class="d-flex align-items-center"
        >
            <DIcon
                name="alert"
                :size="24"
            />
            <div class="pr-2">
                {{ __('administrations.cron_jobs.messages.alert_message') }}
            </div>
            <DButton
                mini
                color="primary"
                :label="__('administrations.cron_jobs.show_jobs')"
                @click="showModal = true"
            />
        </DAlert>
        <CronJobMonitoringDetailsModal
            :show-modal="showModal"
            :cron-job-errors="cronJobErrors"
            @close-modal="showModal = false"
        />
    </div>
</template>

<script>
import CronJobMonitoringDetailsModal from './CronJobMonitoringDetailsModal'

export default {
    name: 'CronJobMonitoringAlert',
    components: { CronJobMonitoringDetailsModal },
    props: {
        cronJobErrors: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            showModal: false
        }
    }
}
</script>
